<script>
export default {
  name: "close-search-svg"
}
</script>

<template>
  <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.5 4.53125L12.0312 6L13.5 7.46875C13.8125 7.78125 13.8125 8.25 13.5 8.53125C13.2188 8.84375 12.75 8.84375 12.4688 8.53125L11 7.0625L9.5 8.53125C9.21875 8.84375 8.75 8.84375 8.46875 8.53125C8.15625 8.25 8.15625 7.78125 8.46875 7.46875L9.9375 6L8.46875 4.53125C8.15625 4.25 8.15625 3.78125 8.46875 3.46875C8.75 3.1875 9.21875 3.1875 9.5 3.46875L11 4.96875L12.4688 3.46875C12.75 3.1875 13.2188 3.1875 13.5 3.46875C13.8125 3.78125 13.8125 4.25 13.5 4.53125ZM16 0C17.0938 0 18 0.90625 18 2V10C18 11.125 17.0938 12 16 12H6.40625C5.875 12 5.375 11.8125 5 11.4375L0.28125 6.71875C0.09375 6.53125 0 6.28125 0 6C0 5.75 0.09375 5.5 0.28125 5.3125L5 0.59375C5.375 0.21875 5.875 0 6.40625 0H16ZM16.5 2C16.5 1.75 16.25 1.5 16 1.5H6.40625C6.28125 1.5 6.125 1.5625 6.03125 1.65625L1.6875 6L6.03125 10.375C6.125 10.4688 6.28125 10.5 6.40625 10.5H16C16.25 10.5 16.5 10.2812 16.5 10V2Z" fill="#ADB5BD"/>
  </svg>
</template>

<style scoped>

</style>
